import {
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Grid,
  GridItem,
  Input,
  Select,
  Image,
} from "@chakra-ui/react";
import { Formik, Form } from "formik";
import { useState } from "react";

const StudentPersonalInformationAppForm = ({ handleNext }) => {
  const [selectedImage, setSelectedImage] = useState(null);

  const initialValues = {
    title: "",
    surname: "",
    firstname: "",
    otherName: "",
    DOB: "",
    gender: "",
    telephone: "",
    postCode: "",
    country: "",
    stateOfOrigin: "",
    address: "",
    passportPhoto: null,
  };

  const handleImageChange = (event, setFieldValue) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImage(reader.result);
      };
      reader.readAsDataURL(file);

      setFieldValue("passportPhoto", file);
    }
  };

  const handleSubmit = (values) => {
    handleNext(values); // Move to the next step
  };

  return (
    <Box p={5} bg="#fff" borderRadius="md" boxShadow="md">
      <Formik initialValues={initialValues} onSubmit={handleSubmit}>
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          setFieldValue,
        }) => (
          <Form>
            <FormControl>
              <FormLabel>Upload Passport Photo</FormLabel>
              <Flex direction="column" alignItems="center">
                <Box
                  w="100px"
                  h="100px"
                  border="1px solid #ccc"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  mb={2}
                >
                  {selectedImage ? (
                    <Image
                      src={selectedImage}
                      boxSize="100px"
                      objectFit="cover"
                    />
                  ) : (
                    <Box
                      w="100px"
                      h="100px"
                      bg="#E2E8F0"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <span>📷</span>
                    </Box>
                  )}
                </Box>
                <Input
                  type="file"
                  accept=".jpg,.png"
                  onChange={(event) => handleImageChange(event, setFieldValue)}
                />

                <FormErrorMessage>{errors.passportPhoto}</FormErrorMessage>
                <Box color="red" fontSize="sm">
                  Picture must not be more than 100KB, only .jpg and .png files
                  are acceptable
                </Box>
              </Flex>
            </FormControl>

            <Grid
              templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }}
              gap={4}
              mt={5}
            >
              {[
                {
                  name: "title",
                  label: "Title",
                  type: "select",
                  options: ["Mr", "Mrs", "Miss", "Dr", "Prof"],
                },
                { name: "surname", label: "Surname" },
                { name: "firstname", label: "Firstname" },
                { name: "otherName", label: "Other Name" },
                { name: "DOB", label: "Date of Birth", type: "date" },
                {
                  name: "gender",
                  label: "Gender",
                  type: "select",
                  options: ["Male", "Female", "Other"],
                },
                { name: "telephone", label: "Telephone Number" },
                { name: "postCode", label: "Post Code" },
                {
                  name: "country",
                  label: "Country",
                  type: "select",
                  options: ["Nigeria", "USA", "UK", "Canada", "Others"],
                },
                { name: "stateOfOrigin", label: "State of Origin" },
                { name: "address", label: "Home Address", colSpan: 2 },
              ].map(({ name, label, type = "text", colSpan, options }) => (
                <GridItem colSpan={colSpan || 1} key={name}>
                  <FormControl isInvalid={errors[name] && touched[name]}>
                    <FormLabel fontSize="16px">{label}</FormLabel>
                    {type === "select" ? (
                      <Select
                        name={name}
                        placeholder={`Select ${label}`}
                        fontSize="small"
                        bg="#F3F3F3"
                        borderRadius="8px"
                        focusBorderColor="#ffffff"
                        borderColor="#FFFFFF"
                        _placeholder={{ color: "#B4B1B1" }}
                        _hover={{ borderColor: "#FFFFFF" }}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values[name]}
                      >
                        {options.map((option) => (
                          <option key={option} value={option}>
                            {option}
                          </option>
                        ))}
                      </Select>
                    ) : (
                      <Input
                        name={name}
                        placeholder="Enter Here"
                        type={type}
                        fontSize="small"
                        bg="#F3F3F3"
                        borderRadius="8px"
                        focusBorderColor="#ffffff"
                        borderColor="#FFFFFF"
                        _placeholder={{ color: "#B4B1B1" }}
                        _hover={{ borderColor: "#FFFFFF" }}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values[name]}
                      />
                    )}
                    <FormErrorMessage>{errors[name]}</FormErrorMessage>
                  </FormControl>
                </GridItem>
              ))}
            </Grid>

            <Flex justifyContent="center" gap={6} mt={10}>
              <Button
                bg="#A6A6A6"
                color="#FFFFFF"
                w="200px"
                // onClick={() => console.log("Cancel")}
              >
                Cancel
              </Button>
              <Button bg="#23A455CC" color="#FFFFFF" w="200px" type="submit">
                Next
              </Button>
            </Flex>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default StudentPersonalInformationAppForm;
